import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-document",
  "use": "icon-document-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document\">\n<path d=\"M5.625 6.25V7.5H14.375V6.25H5.625Z\" fill=\"black\" />\n<path d=\"M11.25 9.375H5.625V10.625H11.25V9.375Z\" fill=\"black\" />\n<path d=\"M3.75 2.5C3.05964 2.5 2.5 3.05964 2.5 3.75V16.25C2.5 16.9404 3.05964 17.5 3.75 17.5H16.25C16.9404 17.5 17.5 16.9404 17.5 16.25V3.75C17.5 3.05964 16.9404 2.5 16.25 2.5H3.75ZM16.25 3.75V16.25H3.75L3.75 3.75H16.25Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol